import { DocumentTextIcon, Cog6ToothIcon } from "@heroicons/react/24/outline";


const Identification = [
    {
        name: 'identification:menu.elevage',
        icon: <DocumentTextIcon className="h-5 w-5" />,
        path: '/identification/elevage'
    },
    {
        name: 'identification:menu.animal',
        icon: <DocumentTextIcon className="h-5 w-5" />,
        path: '/identification/animal'
    },
    {
        name: 'identification:menu.earring_order',
        icon: <DocumentTextIcon className="h-5 w-5" />,
        path: '/identification/earring_order'
    },
    {
        name: 'identification:menu.administration',
        icon: <Cog6ToothIcon className="h-5 w-5" />,
        path: '/identification/administration',
        submenus: [
            { name: 'identification:menu.administration.espece', path: '/identification/administration/espece' },
            { name: 'identification:menu.administration.-animal', path: '/identification/administration/categorie-animal' },
            { name: 'identification:menu.administration.type-elevage', path: '/identification/administration/type-elevage' },
            { name: 'identification:menu.administration.motif-mouvement', path: '/identification/administration/motif-mouvement' },
            { name: 'identification:menu.administration.type-race', path: '/identification/administration/type-race' },
            { name: 'identification:menu.administration.race', path: '/identification/administration/race' },
            { name: 'identification:menu.administration.type-production', path: '/identification/administration/type-production' },
        ]
    }

    
];

export default Identification;